import { render } from "./RegionBarChart.vue?vue&type=template&id=89e28f66"
import script from "./RegionBarChart.vue?vue&type=script&lang=js"
export * from "./RegionBarChart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__